import { Component, OnInit, Inject, OnDestroy } from '@angular/core'
import { Router, Event, NavigationEnd } from '@angular/router'
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular'
import { InteractionStatus, EventMessage, EventType } from '@azure/msal-browser'
import { Subject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'
import { AzureService } from './core/auth/azure.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'strategic_pricing'
  isIframe = false
  loginDisplay = false
  enableNavBar = false
  private readonly _destroying$ = new Subject<void>()

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private azureService: AzureService
  ) {
    this.loginUrl()
    this.azureService.setAuthServiceInstance(authService)
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener // Remove this line to use Angular Universal
    this.setLoginDisplay()

    this.authService.instance.enableAccountStorageEvents() // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/'
        } else {
          this.setLoginDisplay()
        }
      })

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay()
        this.checkAndSetActiveAccount()
        this.azureService.getRoles()
      })
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0
  }

  loginUrl() {
    this.enableNavBar = false
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        console.log(event.url)
        if (event.url === '/login') {
          this.enableNavBar = false
        } else {
          this.enableNavBar = true
        }
      }
    })
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount()

    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts()
      this.authService.instance.setActiveAccount(accounts[0])
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined)
    this._destroying$.complete()
  }
}
